import { Fragment } from 'react';

import { RichTextView } from '@/components/RichTextEditor/RichTextView';
import { MessageUnionType, S3DataSchema } from '@/types/schema';
import {
  getMessageContent,
  getMessageFields,
  getMessageType,
} from '@/utils/messages';
import { cn } from '@/utils/tailwind';

import { useFancyRendering } from './RichTextEditor/utils/fancyRenderContext/useFancyRender';

export function RunMessagesInline(props: {
  messages: MessageUnionType[] | undefined | null;
  toolCalls?: any;
  attachments?: Record<string, S3DataSchema>;
  omitMaxHeight?: boolean;
}) {
  const { fancyRendering } = useFancyRendering();
  return (
    <div className="flex flex-col gap-3">
      {props.messages?.map((message, idx, lst) => {
        const content = getMessageContent(message);

        return (
          <Fragment key={idx}>
            <div
              key={idx}
              className={cn(
                'overflow-auto',
                !props.omitMaxHeight && 'max-h-[25vh]'
              )}
            >
              {lst.length > 1 && (
                <strong className="text-sm font-semibold uppercase text-tertiary">
                  {getMessageType(message)}
                </strong>
              )}
              {content != null ? (
                <p className="whitespace-pre-wrap break-words">
                  <RichTextView
                    content={content}
                    toolCalls={props.toolCalls}
                    attachments={props.attachments}
                    fancyRendering={fancyRendering}
                    showToolCalls
                  />
                </p>
              ) : (
                <pre className="max-w-full whitespace-pre-wrap break-words">
                  {JSON.stringify(
                    getMessageFields(message)?.additional_kwargs ?? message,
                    null,
                    2
                  )}
                </pre>
              )}
            </div>

            {idx + 1 !== lst.length && (
              <div className="h-px w-full bg-tertiary" />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
